import React, { useRef } from 'react';
import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize, useIsHydrated } from '../../hooks';
import { WelcomeSection } from '../../components/WelcomeSection';
import { TelegramBanner } from '../../components/Banner';
import { HomePageSearch } from '../../components/HomePageSearch';
import { CategorySelector } from '../../components/CategorySelector';
import { FeedHeader } from '../../components/FeedHeader';
import { Feed, FeedPlace, useInfiniteFeed } from '../../components/Feed';

import { usePromptFeedColumns, useSelectedCategories } from './HomePage.hooks';
import { HomePageMeta } from './HomePage.meta';
import './HomePage.scss';

const b = cn('home-page');

export const HomePage: React.FC = React.memo(() => {
    const isLoaded = useIsHydrated();

    const categoriesRef = useRef<HTMLDivElement>(null);

    const columns = usePromptFeedColumns();
    const screenSize = useGetScreenSize();
    const isTouch = screenSize <= ScreenSize.Tablet;

    const { selectedCategories, updateSelectedCategories } = useSelectedCategories();

    // const handleCharactersBannerClick = useCallback(() => {
    //     updateSelectedCategories(['characters']);
    //     categoriesRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }, [updateSelectedCategories]);

    const {
        prompts,
        collections,
        challenges,
        courses,
        loading: isLoading,
        hasMore,
    } = useInfiniteFeed({ threshold: 600 });

    return (
        <div className={b()}>
            <HomePageMeta categoryId={selectedCategories[0] || null} />
            <WelcomeSection />
            <div className={b('content')}>
                <TelegramBanner />
                {/* <CharactersBanner onClick={handleCharactersBannerClick} /> */}
                <HomePageSearch />
                <div ref={categoriesRef} className={b('categories', { loaded: isLoaded })}>
                    <CategorySelector
                        selectedCategories={selectedCategories}
                        onChangeCategories={updateSelectedCategories}
                        size={isTouch ? 'normal' : 'large'}
                        centered
                    />
                </div>
                <FeedHeader anchorRef={categoriesRef} />
                <Feed
                    containerClassName="home-page__feed"
                    collections={collections}
                    prompts={prompts}
                    courses={courses}
                    challenges={challenges}
                    columns={columns}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    needMarkPromptsAsViewed
                    place={FeedPlace.HomePage}
                />
            </div>
        </div>
    );
});

HomePage.displayName = 'HomePage';
